export default class Csm {
  id?: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.name = obj.name || null;
  }

  public static of(obj: any): Csm {
    return new Csm(obj || {});
  }

  public static ofList(obj: any[]): Csm[] {
    return obj.map(this.of);
  }
}
